import { useProfileSectionEditing } from "@/hooks/use-profile-section-form";
import { textOrNotRecorded } from "@/lib/people";

import { EditAdditionalNotesForm } from "../forms/EditAdditionalNotesForm";
import { ProfileSectionCard } from "../ProfileSectionCard";
import { ProfileSectionEditButton } from "../ProfileSectionEditButton";

interface AdditionalNotesSectionProps {
  nurseryId: string;
  userId: string;
  additionalNotes: string | null;
  canEdit: boolean;
}

export function AdditionalNotesSection({
  nurseryId,
  userId,
  additionalNotes,
  canEdit,
}: AdditionalNotesSectionProps) {
  const { editing, editButtonRef, startEditing, stopEditing } =
    useProfileSectionEditing();

  return (
    <ProfileSectionCard
      title="Additional notes"
      testId="profile-section-additional-notes"
      action={
        canEdit &&
        !editing && (
          <ProfileSectionEditButton
            ref={editButtonRef}
            section="additional notes"
            onClick={startEditing}
          />
        )
      }
      editForm={
        canEdit &&
        editing && (
          <EditAdditionalNotesForm
            nurseryId={nurseryId}
            userId={userId}
            additionalNotes={additionalNotes}
            onDone={stopEditing}
          />
        )
      }
    >
      <p className="text-body text-default-font whitespace-pre-wrap break-words">
        {textOrNotRecorded(additionalNotes)}
      </p>
    </ProfileSectionCard>
  );
}
